import React, { useEffect, useState } from "react";
import { ErrorMessage, FieldArray, Formik } from "formik";
import * as yup from "yup";
import toast, { Toaster } from "react-hot-toast";
import clsx from "clsx";
import $ from "jquery";
import { createRole, getPermissions } from "../../models/_user";
import Breadcrumb from "../Common/Breadcrumb";

const validationSchema = yup.object({
  name: yup.string().required("Name is required"),
  permission: yup.array().min(1, "Permission is required"),
});

const CreateRole = () => {
  const [loading, setLoading] = useState(false);
  const [permissionDB, setPermissionDB] = useState([]);

  const fetchdata = async () => {
    try {
      const permissionRecord = await getPermissions();
      const permissionResults: any = permissionRecord ? permissionRecord : [];
      permissionResults.sort(function (a: any, b: any) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        return 0;
      });

      setPermissionDB(permissionResults);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchdata();
  }, []);

  return (
    <>
      <div id="kt_app_toolbar" className="app-toolbar py-2 pt-4">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-xxl d-block d-lg-flex d-md-flex d-xl-flex flex-stack px-3"
          style={{ maxWidth: "100%" }}
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap">
            <h1 className="page-heading d-flex text-dark fw-bold fs-1 flex-column justify-content-center my-0">
              Create Role
            </h1>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3 mt-3 mt-lg-0 mt-md-0">
            <Breadcrumb
              links={[
              { label: "Home", href: "/dashboard", isActive: false },
              { label: "Create Role", href: "", isActive: true },
              ]}
            />
          </div>
        </div>
      </div>

      <div className="card mx-xl-4 mt-9">
        <Formik
          enableReinitialize
          initialValues={{
            name: "",
            permission: [],
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm, setSubmitting }) => {
            setLoading(true);
            const result = await createRole(values.name, values.permission);
            if (result?.data?.data?.createRole) {
              $("input[type=checkbox]").prop("checked", function () {
                $(this).prop("checked", false);
              });
              toast.success("Role created successfully");
              setLoading(false);
              setSubmitting(false);
              resetForm();
            } else {
              setSubmitting(false);
              setLoading(false);
              const messages = result?.data?.errors.map((e: any) => e.message);
              toast.error(messages.join(","));
            }
          }}
        >
          {({ handleChange, handleSubmit, values, errors, touched }) => (
            <div className="card-body w-100 p-lg-7 p-md-7 p-5">
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                    <label className="form-label fs-4 required fw-bold">
                      Name
                    </label>
                    <input
                      className={clsx("form-control", {
                        "is-invalid": Boolean(errors.name) && touched.name,
                      })}
                      name="name"
                      id="name"
                      value={values.name}
                      onChange={handleChange}
                    />
                    <div className="text-danger text-align-top-center mt-2">
                      <ErrorMessage name="name" />
                    </div>
                  </div>

                  <div className="col-xl-9 col-lg-12 col-md-12 col-12 p-2 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                    <label className="form-label fs-4 required fw-bold ps-1">
                      Permission
                    </label>
                    <FieldArray name="permission">
                      {(arrayHelpers) => {
                        return (
                          <>
                            <div className="row">
                              {Array.from(permissionDB).map(
                                (value: any, index) => {
                                  return (
                                    <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                                      <label
                                        className="ms-2 fs-5 form-check form-check-sm form-check-custom form-check-solid me-5 align-items-center d-flex mt-1 ms-2"
                                        key={index}
                                      >
                                        <input
                                          id="permission"
                                          className="form-check-input"
                                          type="checkbox"
                                          name="permission"
                                          value={value.id}
                                          onChange={(e) => {
                                            if (e.target.checked)
                                              arrayHelpers.push(e.target.value);
                                            else {
                                              const idx =
                                                values.permission.findIndex(
                                                  (e: any) => e.id === value.id
                                                );
                                              arrayHelpers.remove(idx);
                                            }
                                          }}
                                        />
                                        <span className="form-check-label fs-5 mb-0 ms-2">
                                          {value.name}
                                        </span>
                                      </label>
                                    </div>
                                 
                                  );
                                }
                              )}
                            </div>

                            <div className="text-danger text-align-top-center mt-2">
                              <ErrorMessage name="permission" />
                            </div>
                          </>
                        );
                      }}
                    </FieldArray>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-3 col-lg-3 col-md-4 col-12 px-xl-5 p-2 mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary me-4 fs-4 w-100"
                    >
                      {loading && (
                        <span
                          className="indicator-progress"
                          style={{ display: "block" }}
                        >
                          Please Wait..
                          <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                        </span>
                      )}
                      {!loading && (
                        <span className="indicator-label">ADD ROLE</span>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </Formik>

        <Toaster
          position="bottom-left"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            className: "",
            duration: 3000,
          }}
        />
      </div>
    </>
  );
};

export default CreateRole;
